import React from 'react';
import { Box, Paper, useTheme } from '@mui/material';
import { CenteredFlexBox, FlexBox } from '../../../../../../../Components/FlexBox';
import CaptionValue from '../../../../../../../Components/CaptionValue/CaptionValue';
import Select from '../../../../../../../Components/Inputs/Select';
import Chip from '../../../../../../../Components/Chip';

const CustomerPaper = function CustomerPaper({
  fullName,
  customerId,
  previousSection,
  branches = [],
  options = [],
  value = '',
  onChange = () => {},
}) {
  const theme = useTheme();

  // Only surface the branch chips when the overlap actually spans different
  // branches; a single shared branch carries no useful information here.
  const hasDistinctBranches =
    new Set(branches.map(({ overlapBranch }) => overlapBranch)).size > 1;

  // Branch chips stay grey until a winner section is picked; then the matching
  // branch turns green and the losing ones turn red.
  const getBranchColor = (overlapSectionId) => {
    if (!value) return theme.palette.grey[500];
    return overlapSectionId?.toString() === value?.toString()
      ? theme.palette.success.main
      : theme.palette.error.main;
  };

  return (
    <Paper variant="outlined">
      <CenteredFlexBox padding="16px" gap="16px">
        <CaptionValue
          flex={2}
          captionStyle={{ textTransform: 'uppercase', fontWeight: 'bold' }}
          captionColor="primary"
          caption="NAME"
          value={fullName}
        />
        {hasDistinctBranches ? (
          <CaptionValue
            flex={3}
            captionStyle={{ textTransform: 'uppercase', fontWeight: 'bold' }}
            captionColor="primary"
            textAlign="center"
            caption="BRANCHES"
            value={
              <FlexBox gap="8px" flexWrap="wrap" justifyContent="center">
                {branches.map(({ overlapSectionId, overlapBranch }) => (
                  <Chip
                    key={overlapSectionId}
                    id={`${customerId}-${overlapSectionId}`}
                    size="small"
                    label={overlapBranch}
                    color={getBranchColor(overlapSectionId)}
                  />
                ))}
              </FlexBox>
            }
          />
        ) : (
          <Box sx={{ flex: 3 }} />
        )}
        <CaptionValue
          flex={1}
          captionStyle={{ textTransform: 'uppercase', fontWeight: 'bold' }}
          captionColor="primary"
          caption="LAST_SECTION"
          value={previousSection ?? 'N/A'}
        />
        <Select
          name="section-select"
          size="small"
          options={options}
          value={value}
          onChange={(newValue) => onChange(customerId, newValue)}
          width="240px"
        />
      </CenteredFlexBox>
    </Paper>
  );
};

export default React.memo(CustomerPaper);
